import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import {handleError} from "../../../helpers/handleError";
import eventBus from "../../../event-bus/eventBus";

const saveClient = {
    namespaced: true,
    state: {
        dataSaveIsFetching: false,
        typeInfoClientSave: "",
        headInfoClientSave: "",
        isClientSave: false,
        textInfoClientSave: "",
    },
    mutations: {
        DATA_SAVE_SUCCESS(state, response) {
            eventBus.$emit("saveClientSuccess", response.data.data.clientId);
        },
        DATA_SAVE_FAILURE(state, error) {
            state.textInfoClientSave = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
            state.typeInfoClientSave = "red";
            state.headInfoClientSave = error.response.data.message;
            state.isClientSave = true;
            state.dataSaveIsFetching = false;
            eventBus.$emit("saveClientFailure", error.response.data.errors, false);
        },
        DATA_SAVE_REQUEST(state, value) {
            state.dataSaveIsFetching = value;
        },
        UPDATE_VISIBLE_MODAL(state, value) {
            state.isClientSave = value;
        },
        RESET_INFO(state) {
            state.textInfoClientSave = "";
            state.headInfoClientSave = "";
            state.typeInfoClientSave = "";
        }
    },
    actions: {
        storeClient: function({ dispatch }, payload) {
            dispatch("requestDataSave", true);
            var promise = sendRequest("post", config.baseURLApi + "/clients", {}, payload.creds);
            promise.then(function (result) {
                if (result[0] === "success") {
                    dispatch("successDataSave", result[1]);
                } else {
                    dispatch("failureDataSave", result[1]);
                }
            })
        },
        successDataSave: function({ commit }, response) {
            commit("DATA_SAVE_SUCCESS", response);
        },
        failureDataSave: function({ commit }, error) {
            commit("DATA_SAVE_FAILURE", error);
        },
        requestDataSave: function({ commit }, value) {
            commit("DATA_SAVE_REQUEST", value);
        },
        updateVisibleModalClient: function({ commit }, value) {
            commit("UPDATE_VISIBLE_MODAL", value);
        },
        resetInfo: function({ commit }) {
            commit("RESET_INFO");
        }
    }
}

export default saveClient;